/**
 * Safe axios utility that checks HTTP status codes and throws errors for non-successful responses
 */

import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';

// Create axios instance with response interceptor
export const safeAxios: AxiosInstance = axios.create();

// Response interceptor to handle HTTP errors
safeAxios.interceptors.response.use(
  (response: AxiosResponse) => response,
  (error) => {
    if (error.response) {
      // Server responded with error status (4xx, 5xx)
      const status = error.response.status;
      const errorMessage = error.response.data?.error || error.response.statusText || 'Unknown error';
      throw new Error(`HTTP ${status}: ${errorMessage}`);
    } else if (error.request) {
      // Request was made but no response received (network error)
      throw new Error('Network error: No response received');
    } else {
      // Something else happened
      throw new Error(`Request error: ${error.message}`);
    }
  }
);

// Convenience methods that use the safe axios instance
export const safeAxiosPut = async (url: string, data: any, config?: AxiosRequestConfig) => {
  return await safeAxios.put(url, data, config);
};

export const safeAxiosPost = async (url: string, data: any, config?: AxiosRequestConfig) => {
  return await safeAxios.post(url, data, config);
};

export const safeAxiosGet = async (url: string, config?: AxiosRequestConfig) => {
  return await safeAxios.get(url, config);
};

export const safeAxiosDelete = async (url: string, config?: AxiosRequestConfig) => {
  return await safeAxios.delete(url, config);
}; 